<ion-content>
  <ion-row
    class="h-100 flex-column ion-justify-content-center ion-align-items-center"
  >
  <ion-spinner name="crescent" color="primary"></ion-spinner>
  </ion-row>
</ion-content>
